template = require('./templates/layout')

module.exports = class DrawerLayout extends Backbone.Marionette.Layout
    template: template

    triggers:
        "click .drawer-pull": "drawer:toggle"

    ui:
        "drawer": ".drawer-container"
        "drawerBody": ".drawer-body"

    regions:
        "drawer": ".drawer-body"
        "content": ".drawer-content"
    open: false

    # The drawer toggle should enable after
    onDrawerEnable: =>
        if @ui.drawer.hasClass('enabled')
            return
        @ui.drawer.removeClass('disabled')
        @ui.drawer.addClass('enabled')

    onDrawerClose: =>
        if ! @ui.drawer.hasClass('open')
            return
        @fullHeight = @ui.drawerBody.height()
        @ui.drawer.removeClass('open')
        @open = false

        @ui.drawerBody.css
            height: @fullHeight
        @ui.drawer.css
            top: -@fullHeight

    onDrawerOpen: =>
        if @ui.drawer.hasClass('open')
            return
        @open = true

        @ui.drawer.addClass('open')
        @ui.drawerBody.css
            height: ""
        @ui.drawer.css
            top: ""

    onDrawerToggle: =>
        if @ui.drawer.hasClass('disabled')
            return

        if @ui.drawer.hasClass('open')
            @onDrawerClose()
        else
            @onDrawerOpen()



// WEBPACK FOOTER //
// ./app/lib/common/drawer/DrawerLayout.coffee